// extracted by mini-css-extract-plugin
export default {"error-box":"style_error-box__uKwPx","error-img":"style_error-img__NpAwl","error-text":"style_error-text__Komb4"};